import React from 'react';
import { Link } from 'react-router-dom';

// Completá tus datos acá para que se reflejen en todo el documento:
const DATOS_EMPRESA = {
  cuit: '', 
  domicilioLegal: '',
  email: 'pascoloquesos@gmail.com'
};

const TerminosYCondiciones = () => {
  return (
    <div style={styles.container}>
      <div style={styles.contentBox}>
        
        {/* Encabezado */}
        <h1 style={styles.mainTitle}>TÉRMINOS Y CONDICIONES DE USO Y VENTA</h1>
        <p style={styles.date}>Última actualización: 10 de Junio de 2026</p>
        
        <hr style={styles.divider} />

        <p style={styles.paragraph}>
          Bienvenido a <strong>pascolo.com.ar</strong>. Los presentes Términos y Condiciones regulan el acceso, 
          navegación y utilización del Sitio, así como las condiciones que rigen la compra de los productos 
          ofrecidos por Páscolo a sus usuarios y clientes.
        </p>

        {/* Sección 1 */}
        <h2 style={styles.sectionTitle}>1. IDENTIFICACIÓN DEL VENDEDOR</h2>
        <ul style={styles.list}>
          <li><strong>Nombre comercial:</strong> Páscolo</li>
          <li><strong>Sitio web:</strong> pascolo.com.ar</li>
          <li><strong>CUIT:</strong> {DATOS_EMPRESA.cuit}</li>
          <li><strong>Domicilio legal:</strong> {DATOS_EMPRESA.domicilioLegal}</li>
          <li><strong>Correo electrónico:</strong> <a href={`mailto:${DATOS_EMPRESA.email}`} style={styles.link}>{DATOS_EMPRESA.email}</a></li>
        </ul>

        {/* Sección 2 */}
        <h2 style={styles.sectionTitle}>2. OBJETO</h2>
        <p style={styles.paragraph}>
          Los presentes Términos y Condiciones regulan el acceso y utilización del sitio web pascolo.com.ar y la compra de productos ofrecidos por Páscolo.
        </p>

        {/* Sección 3 */}
        <h2 style={styles.sectionTitle}>3. PRODUCTOS</h2>
        <p style={styles.paragraph}>
          Páscolo comercializa productos alimenticios y agropecuarios, incluyendo quesos Gouda con distintos saborizantes, leche pasteurizada y fardos de alfalfa.
        </p>
        <p style={styles.paragraph}>
          Las imágenes y descripciones publicadas tienen carácter ilustrativo y podrán presentar diferencias menores respecto del producto final entregado.
        </p>

        {/* Sección 4 */}
        <h2 style={styles.sectionTitle}>4. PROCESO DE COMPRA</h2>
        <p style={styles.paragraph}>
          La realización de un pedido a través del Sitio constituye una solicitud formal de compra por parte del usuario.
        </p>
        <p style={styles.paragraph}>
          La venta quedará sujeta y condicionada a la efectiva verificación del pago por parte de la pasarela financiera y a la disponibilidad de stock en los sistemas.
        </p>

        {/* Sección 5 */}
        <h2 style={styles.sectionTitle}>5. PRECIOS</h2>
        <p style={styles.paragraph}>
          Todos los precios publicados se encuentran expresados en pesos argentinos, salvo indicación expresa en contrario.
        </p>
        <p style={styles.paragraph}>
          Páscolo se reserva el derecho de modificar los precios sin previo aviso respecto de aquellos productos que aún no hayan sido adquiridos o confirmados mediante pago.
        </p>

        {/* Sección 6 */}
        <h2 style={styles.sectionTitle}>6. MEDIOS DE PAGO</h2>
        <p style={styles.paragraph}>
          Los pagos se realizan exclusivamente mediante la plataforma externa e integrada de <strong>Mercado Pago</strong>.
        </p>
        <p style={styles.paragraph}>
          El procesamiento técnico del pago es efectuado por dicha plataforma conforme a sus propios términos, condiciones y normativas de seguridad, deslindando a Páscolo de la gestión directa de datos bancarios.
        </p>

        {/* Sección 7 */}
        <h2 style={styles.sectionTitle}>7. RETIRO DE PRODUCTOS</h2>
        <p style={styles.paragraph}>
          Los productos adquiridos deberán ser retirados por el comprador en la fábrica o en el punto de retiro oportunamente informado por Páscolo.
        </p>
        <p style={styles.paragraph}>
          Al momento del retiro, el comprador o la persona autorizada deberá presentarse con la documentación o información necesaria para acreditar la titularidad de la compra cuando le sea requerida.
        </p>

        {/* Sección 8 */}
        <h2 style={styles.sectionTitle}>8. DISPONIBILIDAD DE STOCK</h2>
        <p style={styles.paragraph}>
          En caso de verificarse una falta de stock imprevista luego de realizada una compra, Páscolo podrá cancelar la operación y gestionará el reintegro total del dinero correspondiente mediante el mismo medio de pago utilizado por el cliente.
        </p>

        {/* Sección 9 */}
        <h2 style={styles.sectionTitle}>9. RESPONSABILIDAD DEL USUARIO</h2>
        <p style={styles.paragraph}>
          El usuario del Sitio garantiza que todos los datos proporcionados durante el proceso de compra son exactos, completos, verídicos y actualizados, haciéndose responsable por cualquier inconveniente logístico derivado de errores en dicha información.
        </p>

        {/* Sección 10 */}
        <h2 style={styles.sectionTitle}>10. PROPIEDAD INTELECTUAL</h2>
        <p style={styles.paragraph}>
          Todo el contenido de este Sitio, incluyendo textos, códigos, imágenes, logotipos, marcas, diseños y elementos gráficos, pertenece en su totalidad a Páscolo o es utilizado legítimamente bajo autorización. Queda estrictamente prohibida su reproducción o distribución sin consentimiento previo.
        </p>

        {/* Sección 11 */}
        <h2 style={styles.sectionTitle}>11. LIMITACIÓN DE RESPONSABILIDAD</h2>
        <p style={styles.paragraph}>
          Páscolo no será responsable por interrupciones temporales del servicio web ocasionadas por tareas de mantenimiento técnico, fallas de proveedores de internet de terceros o eventos fortuitos de fuerza mayor.
        </p>

        {/* Sección 12 */}
        <h2 style={styles.sectionTitle}>12. MODIFICACIONES</h2>
        <p style={styles.paragraph}>
          Páscolo podrá modificar los presentes Términos y Condiciones en cualquier momento cuando lo considere necesario. Las nuevas versiones entrarán en plena vigencia a partir del instante de su publicación en el Sitio.
        </p>

        {/* Sección 13 */}
        <h2 style={styles.sectionTitle}>13. LEGISLACIÓN APLICABLE</h2>
        <p style={styles.paragraph}>
          Los presentes Términos y Condiciones se rigen, interpretan y aplican bajo las leyes vigentes de la República Argentina. Ante cualquier divergencia, las partes se someterán a la jurisdicción de los tribunales competentes.
        </p>

        {/* Botón de Retorno */}
        <div style={styles.footerAction}>
          <Link to="/" style={styles.btnPrimary}>Volver a la Tienda</Link>
        </div>

      </div>
    </div>
  );
};

// Estilos consistentes con la Política de Privacidad
const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#f9fafb',
    padding: '40px 20px',
    minHeight: '100vh'
  },
  contentBox: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
    maxWidth: '800px',
    width: '100%',
    fontFamily: 'system-ui, -apple-system, sans-serif'
  },
  mainTitle: {
    fontSize: '26px',
    fontWeight: '700',
    color: '#111827',
    marginBottom: '8px',
    letterSpacing: '-0.5px'
  },
  date: {
    fontSize: '14px',
    color: '#6b7280',
    marginBottom: '20px'
  },
  divider: {
    border: '0',
    borderTop: '1px solid #e5e7eb',
    marginBottom: '24px'
  },
  sectionTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#111827',
    marginTop: '26px',
    marginBottom: '12px'
  },
  paragraph: {
    fontSize: '15px',
    color: '#374151',
    lineHeight: '1.6',
    marginBottom: '12px'
  },
  list: {
    fontSize: '15px',
    color: '#374151',
    lineHeight: '1.6',
    paddingLeft: '24px',
    marginBottom: '16px'
  },
  link: {
    color: '#000000',
    fontWeight: '500',
    textDecoration: 'underline'
  },
  footerAction: {
    marginTop: '40px',
    textAlign: 'center'
  },
  btnPrimary: {
    display: 'inline-block',
    backgroundColor: '#000000',
    color: '#ffffff',
    padding: '12px 24px',
    borderRadius: '6px',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '14px'
  }
};

export default TerminosYCondiciones;